import React from 'react';
import styles from './Step2DesktopContent.module.css';
import { ItemTypeEntity } from '@entities/ItemType/Types';
import { ParsedFragmentEntity } from '@entities/ParsedFragment/Types';
import {
    ViewItemTypesModeEnum,
    ViewItemTypesModeType,
} from '@modules/Steps/Shared/Enums/ViewItemTypesModeEnum';
import { StepContentElementWrapper } from '@modules/Steps/Shared/Ui/Wrappers/StepContentElementWrapper/StepContentElementWrapper';
import { CostSummaryHeaderStep2 } from '@modules/Steps/Shared/Widgets/CostSummaryHeaderStep2/CostSummaryHeaderStep2';
import { FragmentInfoStep2 } from '@modules/Steps/Components/Step2/Step2DesktopContent/FragmentInfoStep2/FragmentInfoStep2';
import { LaborAndToolsItemTypesInfoStep2 } from '@modules/Steps/Components/Step2/LaborAndToolsItemTypesInfoStep2/LaborAndToolsItemTypesInfoStep2';
import { CustomProjectStep2ElementsIdsEnum } from '@modules/Steps/Shared/Enums/CustomProjectStep2ElementsIdsEnum';

interface Step2DesktopContentProps {
    fragments: ParsedFragmentEntity[];
    fragmentsViewMode: ViewItemTypesModeType;
    laborItemTypes?: ItemTypeEntity[];
    toolItemTypes?: ItemTypeEntity[];
}

const Step2DesktopContent: React.FC<Step2DesktopContentProps> = ({
    fragments,
    fragmentsViewMode,
    laborItemTypes,
    toolItemTypes,
}) => {
    const filteredFragments = fragments.filter(
        fragment =>
            fragment.itemTypes.length > 0 &&
            fragment.itemTypes.some(itemType => itemType.qty > 0)
    );

    return (
        <div
            className={styles.wrapper}
            id={CustomProjectStep2ElementsIdsEnum.WORK_AREA_STEP2_SECTION}
        >
            <StepContentElementWrapper>
                <CostSummaryHeaderStep2 itemTypesViewMode={fragmentsViewMode} />
                <div className={styles.fragmentsItemsTypesWrapper}>
                    {filteredFragments.map(fragment => (
                        <FragmentInfoStep2
                            fragment={fragment}
                            key={fragment.uuid}
                        />
                    ))}

                    {fragmentsViewMode ===
                        ViewItemTypesModeEnum.MaterialsLaborTools &&
                        laborItemTypes &&
                        laborItemTypes.length > 0 && (
                            <LaborAndToolsItemTypesInfoStep2
                                title="Labour required for task (optional)"
                                description="Indicative labour costs for each section, not purchasable."
                                itemTypes={laborItemTypes}
                            />
                        )}

                    {fragmentsViewMode ===
                        ViewItemTypesModeEnum.MaterialsLaborTools &&
                        toolItemTypes &&
                        toolItemTypes.length > 0 && (
                            <LaborAndToolsItemTypesInfoStep2
                                title="Tools required for task (optional)"
                                description="You can select the tools you require, these are purchasable from the supplier you select."
                                itemTypes={toolItemTypes}
                            />
                        )}
                </div>
            </StepContentElementWrapper>
        </div>
    );
};

export default React.memo(Step2DesktopContent);
